import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/addHours/index.js';

var require$$7 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$7 as default };
